var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "default-page" }, [
    _vm.index > -1
      ? _c(
          "div",
          {
            staticClass: "content",
            style: {
              minHeight: _vm.height ? _vm.height : _vm.minHeight + "px",
              "--imgWidth": _vm.imgWidth,
            },
          },
          [
            _c("div", { staticClass: "content-list" }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: _vm.contentList[_vm.index].url, alt: "" },
              }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.contentList[_vm.index].text) + "~")]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }